import type ExcelJS from 'exceljs'

/** Текст ячейки ExcelJS как строка (с trim).
 *
 *  `cell.value` — не всегда примитив: rich text (часть текста жирным/цветом,
 *  а WPS Office часто сохраняет так весь текст), гиперссылка (Excel сам
 *  превращает URL/e-mail в ссылку) и формула приходят объектами, и
 *  `String(value)` даёт «[object Object]». Ровно так в заметки квот попадал
 *  мусор при загрузке Excel-ответа поставщика (обратная связь закупщика,
 *  03.07.2026). Разбираем все формы значения явно. */
export function readCellText(cell: ExcelJS.Cell): string {
  return cellValueToText(cell.value).trim()
}

function cellValueToText(v: ExcelJS.CellValue): string {
  if (v == null) return ''
  if (typeof v === 'object') {
    if (v instanceof Date) return v.toISOString()
    if ('richText' in v) return v.richText.map((r) => r.text).join('')
    if ('hyperlink' in v) return cellValueToText(v.text ?? v.hyperlink)
    if ('formula' in v || 'sharedFormula' in v) return cellValueToText(v.result)
    if ('error' in v) return ''
    return ''
  }
  return String(v)
}
